import { axiosInstance } from "./BaseService" 

// estoques
export async function fetchInventoryData() {
  try {
    const response = await axiosInstance.get('/merchandise/inventory/metrics');
    return response.data;
  } catch (err) {
    throw err;
  }
};

export async function fetchInventoryDiagnosisData() {
  try {
    const response = await axiosInstance.get('/merchandise/inventory/diagnosis');
    return response.data;
  } catch (err) {
    throw err;
  }
}

// oportunidades
export async function getOpportunitiesByForecastIdAndProductId(productId) {
  try {
    const response = await axiosInstance.get(`/merchandise/opportunities/product?productId=${productId}`);
    return response.data;
  } catch(err) {
    throw err;
  }
}

export async function getOpportunitiesCount() {
  try {
    const response = await axiosInstance.get('/merchandise/opportunities/counter');
    return response.data;
  } catch(err) {
    throw err;
  }
}

export async function getOpportunitiesByStatus(filter) {
  try {
    const params = filter ? `?filter=${filter}` : '';
    const response = await axiosInstance.get(`/merchandise/opportunities/status${params}`);
    return response.data;
  } catch(err) {
    throw err;
  }
}

export async function updateOpportunityStatus({ opportunityId, status, removalReason }) {
  try {
    const response = await axiosInstance.patch('/merchandise/opportunities/status', {
      opportunityId,
      status,
      removalReason
    });
    return response;
  } catch(err) {
    throw err;
  }
}

export async function fetchOpportunitiesTrends() {
  try {
    const response = await axiosInstance.get('/merchandise/opportunities/trends');
    return response.data;
  } catch(err) {
    throw err;
  }
}

export async function fetchOpportunitiesTrendsDetails() {
  try {
    const response = await axiosInstance.get('/merchandise/opportunities/trends/details');
    return response.data;
  } catch(err) {
    throw err;
  }
}

export async function fetchOpportunitiesDetails() {
  try {
    const response = await axiosInstance.get('/merchandise/opportunities/detailed');
    return response.data;
  } catch(err) {
    throw err;
  }
}

export async function fetchMerchandiseAnalytics() {
  try {
    const response = await axiosInstance.get('/merchandise/analytics');
    return response.data;
  } catch(err) {
    throw err;
  }
}

// abastecimento
export async function fetchSupplyAdjustments(storeId, page, pageSize) {
  try {
    const params = new URLSearchParams({ storeId });
    if (page) params.append('page', page);
    if (pageSize) params.append('pageSize', pageSize);

    const response = await axiosInstance.get(`/merchandise/supply?${params.toString()}`);
    return response.data;
  } catch(err) {
    throw err;
  }
}

// open to buy
export async function fetchConsolidatedOtb(cycleId) {
  try {
    const params = cycleId ? `?cycleId=${cycleId}` : '';
    const response = await axiosInstance.get(`/merchandise/otb/consolidated${params}`);
    return response.data;
  } catch(err) {
    throw err;
  }
};

// export async function fetchOtbDetailByLevel(cycleId) {
//   try {
//     const params = cycleId ? `?cycleId=${cycleId}` : '';
//     const response = await axiosInstance.get(`/merchandise/otb/categories${params}`);
//     return response.data;
//   } catch (err) {
//     throw err;
//   }
// };

export async function fetchOtbDetailByLevel(cycleId, category) {
  try {
    const params = new URLSearchParams();
    if (cycleId) params.append('cycleId', cycleId);
    if (category) params.append('category', category);
    const query = params.toString();
    const response = await axiosInstance.get(`/merchandise/otb/categories${query ? `?${query}` : ''}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export async function fetchOtbsCycles() {
  try {
    const response = await axiosInstance.get(`/merchandise/otb/available`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export async function fetchOtbPerformanceByLevel(cycleId) {
  try {
    const params = cycleId ? `?cycleId=${cycleId}` : '';
    const response = await axiosInstance.get(`/merchandise/otb/performance${params}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export async function fetchOtbSalesPlan() {
  try {
    const response = await axiosInstance.get(`/merchandise/otb/sales-plan`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export async function fetchOtbSalesPlanDetailed(productHierarchyNodeId, parentLevelId) {
  try {
    const params = new URLSearchParams({ productHierarchyNodeId, parentLevelId });
    const response = await axiosInstance.get(`/merchandise/otb/sales-plan/detailed?${params.toString()}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export async function saveOtbVersion(cycleId, { versionName, edits }) {
  try {
    const response = await axiosInstance.post(`/merchandise/otb/${cycleId}/versions`, {
      versionName,
      edits,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};